import { render, staticRenderFns } from "./body_atas.vue?vue&type=template&id=840c365e&"
import script from "./body_atas.vue?vue&type=script&lang=js&"
export * from "./body_atas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports